"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var slider_1 = __importDefault(require("../helpers/slider"));
var Gallery = /** @class */ (function () {
    function Gallery() {
        this.config = {
            slider: '[data-gallery-slider]',
            featuredImg: '[data-gallery-featured-img]',
            item: '[data-gallery-item]',
            className: {
                selected: 'gallery__slider-item--selected'
            }
        };
    }
    Gallery.prototype.init = function () {
        var _this = this;
        var nodeList = document.querySelectorAll(this.config.slider);
        nodeList.forEach(function (node) {
            var currentSlider = slider_1.default.init(node, { items: 4.5 });
            var currentSliderInfo = currentSlider.getInfo();
            var items = currentSliderInfo.container.querySelectorAll(_this.config.item);
            currentSlider.events.on('transitionEnd', _this.handleTransitionEnd.bind(_this));
            currentSliderInfo.container.querySelector('.tns-slide-active').classList.add(_this.config.className.selected);
            items.forEach(function (item, index) { return item.addEventListener('click', _this.handleClick.bind(_this)); });
        });
    };
    Gallery.prototype.update = function () {
        var featuredImg = document.querySelector(this.config.featuredImg + ' img');
        var activeItem = document.querySelector('.' + this.config.className.selected + ' img');
        featuredImg.src = activeItem.src;
    };
    Gallery.prototype.handleTransitionEnd = function () {
        this.update();
    };
    Gallery.prototype.handleClick = function (event) {
        var _this = this;
        var parentNode = event.target.parentNode;
        if (parentNode.dataset.galleryItem) {
            document.querySelectorAll(this.config.item).forEach(function (item) { return item.classList.remove(_this.config.className.selected); });
            parentNode.classList.add(this.config.className.selected);
            this.update();
        }
    };
    return Gallery;
}());
exports.default = new Gallery();
